import FavouriteOnboardingDialogue from './FavouriteOnboardingDialogue';

export default FavouriteOnboardingDialogue;
